import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/industries/SocialMediaIndustries.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Partials/DynamicPortfolio.tsx");
